import React, { useEffect } from "react";
import "./Layout.css";
import Header from "./Header";
import LeftSidebar2 from "../Routes/LeftSidebar2";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import appRoutes from "../Routes/AppRoutes";
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LayoutFacebookAutomation from "../views/newFacebookCampaign/LayoutFacebookAutomation";
import LayoutGoogleAutomation from "../views/newGoogleCampaign/LayoutGoogleAutomation";
import useAuth from "../hooks/useAuth";
import NotFoundPage from "../components/common/NotFound";
import Loader from "../utils/Loader";

const CommonLayout = ({userData}) => {
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [activeStep, setActiveStep] = useState(1);
  const [creationRandomId, setCreationRandomId] = useState(
    Date.now() * 1000000 + Math.floor(Math.random() * 1000000)
  );

  const { loading, isLoggedin, user } = useAuth()

  const handleStep = (step) => {
    setActiveStep(step);
  };

  if (loading) {
    return <Loader />
  }

  if (!isLoggedin) {
    return <NotFoundPage />
  }

  return (
    <div className="main-sec">
      <ToastContainer />
      <Header user={user} />
      <div className="left-sec">
        <LeftSidebar2
          toggleSidebar={toggleSidebar}
          setToggleSidebar={(v) => setToggleSidebar(v)}
          setCreationRandomId={setCreationRandomId}
        />
      </div>
      <div
        className={`transition-all duration-500 ${toggleSidebar ? "ml-[218px]" : "ml-[48px]"
          } right-sec`}
      >

        <div className="right-component">
          <Routes>
            {/* Dynamically rendering routes from appRoutes array */}
            {appRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
            <Route
              path="/Ad-Manager/Facebook-Ad-Manage"
              element={
                <LayoutFacebookAutomation
                  setCreationRandomId={setCreationRandomId}
                />
              }
            />
            <Route
              path="/Ad-Manager/Google-Ad-Manage"
              element={<LayoutGoogleAutomation />}
            />
            <Route path="*" element={<Navigate to={userData ? "/repository" : "/not-found"} />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default CommonLayout;
